export default {
    "progress": 1,
    "dispute": 2,
    "draft": 3,
    "open": 4,
    "review": 5,
    "closed": 6,
}
